<template>
    <div class="d-flex flex-column flex-shrink-1">
        <div class="d-flex justify-content-center" v-if="$route.name !== 'results'">
            <router-link :to="{ name: 'results' }" :class="{ 'active': $route.name === 'overall' }" class="w-100 hover-darken text-center p-1 rounded-0 text-white">
                <i class="fas fa-chevron-down"></i>
            </router-link>
        </div>
        <router-view class="px-5 py-2 overflow-auto pretty-scroll-theme"  style="max-height: 350px"/>
        <div class="d-flex align-items-center text-white" style="border-top: 3px solid rgba(0, 0, 0, 0.3);">
            <button type="button" class="btn btn-dark rounded-0 h-100" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-bars mr-2"></i>
                <h6 class="navbar-brand mr-0 mb-0">{{ $t('js.backend.live.ballot_results') }}</h6>
            </button>
            <div class="dropdown-menu">
                <router-link :to="$route.name === 'overall' ? { name: 'results' } : { name: 'overall' }" :class="{ 'active': $route.name === 'overall' }" class="text-truncate dropdown-item" style="max-width: 250px">
                    {{ $t('js.backend.live.overview')}}
                </router-link>
                <router-link v-for="slide in ballotSlides" :key="slide.id" :to="parseInt($route.params['slide_id']) === slide.id ? { name: 'results' } : { name: 'ballot_summary', params: {slide_id: slide.id} }" :class="{ 'active': parseInt($route.params['slide_id']) === slide.id }" class="text-truncate dropdown-item" style="max-width: 250px">
                    <span class="badge badge-dark">{{ slide.position}}</span>
                    <i v-if="slide.result" class="fas fa-poll text-success" v-tooltip="$t('js.tooltips.result_ready')"></i>
                    {{ title(slide) }}
                </router-link>
            </div>

            <div id="ballot_results_bar" class="nav d-flex flex-grow-1 pretty-scroll" style="overflow-x: auto; width: 1px; flex-wrap: nowrap">
                <router-link :to="$route.name === 'overall' ? { name: 'results' } : { name: 'overall' }" :class="{ 'active': $route.name === 'overall' }" class="btn btn-dark text-center rounded-0 py-2 text-white">
                    <div>
                        {{ $t('js.backend.live.overview')}}
                    </div>
                </router-link>
                <router-link v-for="slide in ballotSlides" :key="slide.id" :to="parseInt($route.params['slide_id']) === slide.id ? { name: 'results' } : { name: 'ballot_summary', params: {slide_id: slide.id} }" :class="{ 'active': parseInt($route.params['slide_id']) === slide.id }" class="btn btn-dark py-2 text-center rounded-0 text-white">
                    <div class="text-truncate" style="max-width: 150px">
                          <span class="badge badge-dark" style="background: rgb(20,20,20)">{{ slide.position}}</span>
                          <i v-if="slide.result" class="fas fa-poll text-success"></i>
                          {{ title(slide) }}
                    </div>
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapGetters, mapState} from "vuex"

    export default {
        name: 'Results',
        computed: {
            ...mapState(['election', 'slides']),
            ...mapGetters(['firstAvailableLocale']),
            ballotSlides(){
                return this.slides.filter(s => s.type === 'Slides::BallotSlide')
            }
        },
        methods: {
            title(slide){
                let title = slide.title[this.firstAvailableLocale];
                if(title === "" || title === undefined){
                    title = this.$t('js.slide.one')+ " #" + slide.position
                }
                return title;
            },
        },
        updated() {
            $('#ballot_results_bar').width("2");  // Dirty hack to make safari show the scroll bar on reload
                                                  // instead of when the user makes it redraw...
        }
    }
</script>